export enum TemplateStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  // Never published. Lists derive it (see getListTemplatePublishStatus); the
  // API's `status` field only knows active/archived.
  DRAFT = 'draft',
}

export enum TemplateActionStatus {
  draft = 'Save as Draft',
  publish = 'Publish',
  view = 'View',
  edit = 'Edit',
  clone = 'Clone',
  move = 'Move',
  toggleWordExport = 'Toggle Word Export',
  share = 'Share',
  unshare = 'Unshare',
}
